export enum FieldSubscribeStatus {
  SUBSCRIBED = 'SUBSCRIBED',
  NOT_SUBSCRIBED = 'NOT_SUBSCRIBED',
  NOT_COMPLETED = 'NOT_COMPLETED',
}
